import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import { Link } from 'react-router'
import { get_jobprovider_profile } from '../../../actions/employerAction'
import store from '../../../store'
import { getChatInvites, get_entitylocker, Islogin } from '../../../actions/accountAction';
import { deleteAccount } from '../../../actions/counsellingproviderAction';

class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoginData: null,
        }
        store.dispatch(Islogin())
    }

    async componentDidMount() {
        if (this.props.EmployerReducer.Profile && !Object.keys(this.props.EmployerReducer.Profile).length) {
            store.dispatch(get_jobprovider_profile());
        }
        window.openCloseSidebar()
        store.dispatch(getChatInvites())

        try {
            const res = await store.dispatch(Islogin());
            this.setState({ isLoginData: res });
        } catch (err) {
        }
    }

    componentDidUpdate(prevProps) {
        const prevUrl = prevProps.actionReducer?.entityUrl;
        const newUrl = this.props.actionReducer?.entityUrl;

        // When URL changes and is not empty
        // Only open external entity locker URLs in new tab
        // Do NOT redirect if it's a local URL (like home page)
        if (newUrl && newUrl !== prevUrl) {
            // Only open external entity locker URLs
            if (newUrl.includes('entity.digilocker.gov.in') || newUrl.includes('digilocker')) {
                window.open(newUrl, "_blank");  // open in new tab
            }
            // If it's a local URL, ignore it - don't redirect anywhere
        }
    }

    getVerifyLink = () => {
        store.dispatch(get_entitylocker())
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value)
        });
    }

    capitalizeFirstLetter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }


    deleteRecord = () => {
        // const { delIndex } = this.state
        // if (delIndex !== "") {
        this.handleDeleteEducation()
        document.getElementById("exampleModaldelete").click()
        // }
    }

    handleDeleteEducation() {
        // store.dispatch(deleteEducation({ id: this.props.counsellingproviderReducer.educations[index].id }));
        store.dispatch(deleteAccount(this.props.EmployerReducer.Profile));

        this.setState({ delIndex: '' })
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }



    render() {
        let Mainprops = this.props;
        return (
            <aside className="col-md-3 widget-sidebar bgEducationSidebar py-3" id="left">
                <div className="list-group w-100">
                    <ul className="nav flex-column flex-nowrap">
                        {/* <li className={"nav-item list-group-item " + (Mainprops.route.path === '/myaccount' ? 'active' : '')}>
                            <Link className="nav-link" to="/myaccount">
                                {this.props.t('dashboard.welcome', {param: 'react'})} {this.props.EmployerReducer.Profile.org_name ?
                                <b>{", " + this.props.EmployerReducer.Profile.org_name}</b> : ''}
                            </Link>
                        </li> */}
                        <Link to="/myaccount" className="date-clr">
                            <div className="d-flex align-items-center justify-content-center w-100 pull-left pt-2 outr-profile text-center">
                                <div className="outr-avtar">
                                    {/* <img alt="avatar"
                                        src={'/images/img-1.png'}
                                        className="avatar mr-2 text-center" /> */}
                                    <i style={{ "fontSize": "60px" }} className="fa fa-briefcase" aria-hidden="true"></i>
                                </div>
                                <div className="mb-2 font-18">
                                    <span className="outr-profile-text">
                                        {this.props.t('login.hi', { param: 'react' }).trimEnd()}, {this.capitalizeFirstLetter(this.props.EmployerReducer.Profile.org_name)}</span>
                                    <br></br>

                                    {/* {this.state.isLoginData === null ? (
                                        <div></div>
                                    ) : this.state.isLoginData.aadhar_card_verified === "0" ? (
                                        <div className="mb-1 font-18 verify-adhar" onClick={() => this.getVerifyLink()}>
                                            {this.props.t('verifyAdhar.verify', { param: 'react' })}
                                            <img alt="verify-adhar" src="/images/verify-adhar.png" style={{ marginLeft: "5px" }} />
                                        </div>
                                    ) : (
                                        <div className="mb-1 font-18 verified-adhar">
                                            {this.props.t('verifyAdhar.profile_verified', { param: 'react' })}
                                            <img alt="verify-adhar" src="/images/adhar_verified.png" style={{ marginLeft: "5px" }} />
                                        </div>
                                    )} */}

                                    {this.props.t('dashboard.WelcomeDashboard', { param: 'react' })}
                                </div>
                            </div>
                        </Link>
                        <div className="bgclass-ete">
                            <li title={this.props.t('sidebar.update_profileDesc', { param: 'react' })} className={"nav-item list-group-item gropitm " + (Mainprops.route.path === '/myprofile' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/myprofile">
                                    <img src="/images/img/profile-icon.svg" alt="profile icon" />
                                    <b>{this.props.t('JobPost.org_profile', { param: 'react' })}</b>
                                </Link>
                            </li>
                            <li title={this.props.t('sidebar.post_job_vacanciesDesc', { param: 'react' })} className={"nav-item list-group-item gropitm " + (Mainprops.route.path === '/post-job' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/post-job">
                                    <img src="/images/img/Buss-icon.svg" alt="Buss icon" />
                                    <b>{this.props.t('sidebar.post_job_vacancies', { param: 'react' })}</b>
                                </Link>
                            </li>
                            <li data-placement="bottom"
                                title="Click here for Forum"
                                className={"nav-item list-group-item gropitm " + (Mainprops.route.path === '/forum' ? 'active' : '')}>
                                <Link className="nav-link" to="/forum">
                                    <img src="/images/img/DIs-icon.svg" alt="DIs icon" />
                                    <b>{this.props.t('forum.title', { param: 'react' })}</b>
                                </Link>
                            </li>
                            <li data-placement="bottom"
                                title="Click here for Forum"
                                className={"nav-item list-group-item gropitm " + (Mainprops.route.path === '' ? 'active' : '')}>
                                <Link className="nav-link" to="#" onClick={(event) => { event.preventDefault(); }} data-toggle="modal" data-target="#exampleModaldelete">
                                    <img src="/images/img/Dlt-icon.svg" alt="Dlt icon" />
                                    <b>{this.props.t('sidebar.del_acc', { param: 'react' })}</b>
                                </Link>

                            </li>
                        </div>

                        <div className="modal fade" id="exampleModaldelete" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ color: "black" }}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h6 className="modal-title" id="exampleModalLabel">Are you sure you want to delete your Account? This action cannot be undone.</h6>
                                        {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button> */}
                                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-footer">
                                        <button aria-label="Ok" type="button" className="btn btn-primary btn-primary2" onClick={() => this.deleteRecord()}>Ok</button>
                                        <button aria-label="Cancel" type="button" className="btn btn-primary btn-primary2" data-dismiss="modal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* <li title={this.props.t('sidebar.search_jobseekerDesc', {param: 'react'})} className={"nav-item list-group-item " + (Mainprops.route.path === '/search' ? 'active' : '')}>
                            <Link className="nav-link"
                                  to="/search"><b>{this.props.t('sidebar.search_jobseeker', {param: 'react'})}</b>
                            </Link></li> */}
                        {/* <li title={this.props.t('sidebar.appliedDesc', {param: 'react'})} className={"nav-item list-group-item " + (Mainprops.route.path === '/schduled-interviews' ? 'active' : '')}>
                            <Link className="nav-link"
                                  to="/applied-jobs"><b>{this.props.t('sidebar.appliedProvider', {param: 'react'})}</b>
                            </Link></li> */}
                        {/* <li  data-placement="bottom"
                                title={this.props.t('sidebar.search_lspDesc', {param: 'react'})}
                                className={"nav-item list-group-item " + (Mainprops.route.path === '/servicesearch' ? 'active' : '')}>
                                <Link className="nav-link"
                                    to="/servicesearch"><b>{this.props.t('sidebar.search_service', {param: 'react'})}</b> </Link>
                            </li> */}
                        {/* <li className={"nav-item list-group-item " + (Mainprops.route.path === '/jobfair' ? 'active' : '')}>
                            <Link className="nav-link"
                                  to="/jobfair"><b>{this.props.t('jobMela.name', {param: 'react'})}</b>
                                <img src={"/images/BLINK.gif"} alt={"New"} />
                            </Link></li> */}
                        {/* <li className={"nav-item list-group-item " + (Mainprops.route.path === '/portal-feedback' ? 'active' : '')}>
                            <Link className="nav-link"
                                  to="/portal-feedback"><b>{this.props.t('sidebar.portal_feedback', {param: 'react'})}</b></Link>
                        </li> */}
                        {/* <li className="nav-item list-group-item" title={this.props.t('sidebar.change_passwordDesc', {param: 'react'})}><Link className="nav-link"
                                    to="/change-password"><b>{this.props.t('sidebar.change_password', {param: 'react'})}</b></Link>
                                    </li> */}
                        {/* <li className={"nav-item list-group-item " + (Mainprops.route.path === '/change-password' ? 'active' : '')}>
                            <a className="nav-link collapsed" href="#submenu1" data-toggle="collapse"
                               data-target="#submenu1"><b>{this.props.t('sidebar.settings', {param: 'react'})} </b></a>
                            <div className="collapse" id="submenu1" aria-expanded="false">
                                <ul className="flex-column pl-2 nav">
                                    <li className="nav-item list-group-item mb-2 p-2"><Link className="nav-link py-0"
                                    to="/change-password"><b>{this.props.t('sidebar.change_password', {param: 'react'})}</b></Link>
                                    </li>
                                </ul>
                            </div>
                        </li> */}
                    </ul>
                </div>

            </aside>
        );
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(Sidebar));
